module.exports = __webpack_public_path__ + "img/button-prepaid_medical_scheme_TC.bd9ba258.png";